export const GET_TAKEN_PRACTICES = 'app/Practices/GET_TAKEN_PRACTICES';
export const GET_TAKEN_PRACTICES_SUCCESS =
  'app/Practices/GET_TAKEN_PRACTICES_SUCCESS';
export const SET_PRACTICES_PROCESSING =
  'app/Practices/SET_PRACTICES_PROCESSING';
export const VIEW_PRACTICE = 'app/Practices/VIEW_PRACTICE';
export const GET_VIEWED_PRACTICE = 'app/Practices/GET_VIEWED_PRACTICES';
export const GET_VIEWED_PRACTICE_RESULT =
  'app/Practices/GET_VIEWED_PRACTICES_RESULT';
